import { useState, useCallback } from "react"

const useSessionState = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const stored = sessionStorage.getItem(key)
      return stored === null ? initialValue : JSON.parse(stored)
    } catch (error) {
      console.warn(`Could not read saved value for ${key}:`, error)
      return initialValue
    }
  })

  const update = useCallback(
    (next) => {
      setValue(next)
      try {
        sessionStorage.setItem(key, JSON.stringify(next))
      } catch (error) {
        console.warn(`Could not save value for ${key}:`, error)
      }
    },
    [key],
  )

  return [value, update]
}

export default useSessionState
